<script lang="ts" setup>
import { Icon } from '@brighterly/lib-lumee-ui'

import { useDisciplineStore } from '@stores/discipline'
import { useKidStore } from '@stores/kid'
import { useSubscriptionStore } from '@stores/subscription'

import { useKidInCustomer } from '@hooks/kid/kid-in-customer.hook'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'BannerProcessing',
})

const disciplineStore = useDisciplineStore()
const kidStore = useKidStore()
const subscriptionStore = useSubscriptionStore()

const {
  kid,
} = useKidInCustomer({ kidId: kidStore.activeKidId! })

const id = computed(() => {
  const value = subscriptionStore.getPaymentRetryData?.subscription?.id || null
  return value ? `#${value}` : ''
})

const eventProps = computed(() => {
  return {
    kid_id: kid.value?.id,
    kid_name: kid.value?.name,
    discipline_id: disciplineStore.activeDiscipline?.id,
    discipline_code: disciplineStore.activeDiscipline?.code,
  }
})

onMounted(() => {
  trackEvent(amplitudeConf.events.bannerView, {
    banner_name: 'retry_payment_processing',
    ...eventProps.value,
  })
})
</script>

<template>
  <div class="processing">
    <div class="processing__info">
      <span class="processing__icon processing__icon--mobile">
        <Icon
          name="arrows-rotate"
          weight="solid"
          size="sm"
          color="inherit"
        />
      </span>
      <div class="processing__content">
        <div class="processing__title btly-text-title-s">
          <span class="processing__icon processing__icon--tablet">
            <Icon
              name="arrows-rotate"
              weight="solid"
              size="sm"
              color="inherit"
            />
          </span>
          Payment for subscription {{ id }} is processing..
        </div>
        <div class="processing__detail btly-text-body-m md:btly-text-body-s xl:btly-text-body-m">
          This may take some time to complete. We'll notify you once it's done.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Others/BannerRetryPayment/BannerProcessing.scss" />
